module.exports = __webpack_public_path__ + "img/icon_inlobby.2a79296a.png";